<template>
    <input
        ref="input"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        class="integer-input"
        :class="{ 'integer-input--erro': erro }"
        :value="value === null || value === undefined ? '' : value"
        :disabled="disabled"
        @input="onInput"
        @focus="$event.target.select()"
        @keydown="onKeydown"
    />
</template>

<script>
// Input de número inteiro (faltas, aulas compensadas, aulas dadas): só dígitos, respeita max e
// avisa o pai para mover o foco (Enter/↓/↑). Mesmo comportamento do diário eletrônico.
export default {
    name: 'IntegerInput',
    props: {
        value: { type: [Number, String], default: '' },
        max: { type: Number, default: 999 },
        disabled: { type: Boolean, default: false },
        erro: { type: Boolean, default: false }
    },
    methods: {
        onInput (e) {
            let valor = String(e.target.value).replace(/\D/g, '').slice(0, 3)
            if (valor !== '' && Number(valor) > this.max) valor = String(this.max)
            e.target.value = valor
            this.$emit('input', valor === '' ? '' : Number(valor))
        },
        onKeydown (e) {
            if (e.key === 'Enter' || e.key === 'ArrowDown') {
                e.preventDefault()
                this.$emit('navegar', 1)
            } else if (e.key === 'ArrowUp') {
                e.preventDefault()
                this.$emit('navegar', -1)
            }
        },
        focus () {
            if (this.$refs.input) this.$refs.input.focus()
        }
    }
}
</script>

<style>
    .integer-input {
        width: 56px;
        height: 28px;
        text-align: center;
        border: 1px solid #1c69b3;
        border-radius: 4px;
        font-size: 13px;
        color: #303133;
        background: #fff;
        outline: none;
    }
    .integer-input:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, .25);
    }
    .integer-input:disabled {
        background: #f5f7fa;
        border-color: #dcdfe6;
        color: #a8abb2;
    }
    .integer-input--erro,
    .integer-input--erro:focus {
        border-color: #f56c6c;
        box-shadow: 0 0 0 2px rgba(245, 108, 108, .2);
    }
</style>
